<template>
	<div id="mapId"></div>
</template>

<script>
export default {
	data() {
		return {
			map: null,
			tipMarker: null,
			currentAreaNode: null,
			districtExplorer: null,
			districtObj: {},
			hoverDistrict: {},
			hoverData: {},

		}
	},
	methods: {
		init() {
			// 创建全国行政图层
			let disCountry = new AMap.DistrictLayer.Country({
				zIndex: 1,
				SOC: 'CHN',
				depth: 1,
				styles: {
					'nation-stroke': '#00BCFF',
					'coastline-stroke': "#00BCFF",
					'province-stroke': '#00BCFF',
					'city-stroke': '#00BCFF',
					'fill': "transparent",
				}
			})

			this.map = new AMap.Map("mapId", {
				zooms: [4, 15],
				zoom: 4,
				defaultCursor: "default",
				layers: [
					disCountry
				]
			});

			let that = this;
			AMapUI.load(['ui/geo/DistrictExplorer'], function (DistrictExplorer) {
				that.districtExplorer = new DistrictExplorer({
					eventSupport: true, //打开事件支持
					map: that.map
				});

				//监听feature的hover事件
				that.districtExplorer.on('featureMouseout featureMouseover', function (e, feature) {
					that.toggleHoverFeature(feature, e.type === 'featureMouseover',
						e.originalEvent ? e.originalEvent.lnglat : null);
				});

				//监听鼠标在feature上滑动
				that.districtExplorer.on('featureMousemove', function (e, feature) {
					//更新提示位置
					that.tipMarker.setPosition(e.originalEvent.lnglat);
				});

				//feature被点击
				that.districtExplorer.on('featureClick', function (e, feature) {
					let props = feature.properties;
					if (that.hoverData[props.adcode] && that.hoverData[props.adcode].totalNums > 0) {
						//有数据才下钻展开
						if (props.level == "province") {
							that.districtObj = {}
						}
						that.hoverDistrict = {};
						that.districtObj[props.level] = { name: props.name, adcode: props.adcode };

						//切换聚焦区域
						that.switch2AreaNode(props.adcode);
						let params = that.handleDistrict();
						that.resetSetItem("district", JSON.stringify(params))
					}
				});

				//外部区域被点击
				that.districtExplorer.on('outsideClick', function (e) {
					let adcode = null;
					if (that.districtObj.district) {
						adcode = that.districtObj.city ? that.districtObj.city.adcode : that.districtObj.province.adcode;
						delete that.districtObj.district
					} else if (that.districtObj.city) {
						adcode = that.districtObj.province ? that.districtObj.province.adcode : 100000;
						delete that.districtObj.city
					} else if (that.districtObj.province) {
						adcode = 100000;
						delete that.districtObj.province
					}

					let params = that.handleDistrict();
					that.resetSetItem("district", JSON.stringify(params));
					that.switch2AreaNode(adcode);
				});

				that.switch2AreaNode(100000)
			})


			this.tipMarker = new AMap.Marker({
				content: null,
				offset: new AMap.Pixel(-10, 0),
				anchor: "bottom-left"
			});

		},
		// marker内容
		markerContent(params) {
			return `<div class="mapMarker">
			<div class="">
				<span>${params.name}</span>&nbsp;
				<span class="numFont">${params.totalNums}</span>
			</div>
			<div class="mapFlex">
				<div>在线 <span class="numFont mapNum">${params.onlineNums}</span></div>
				<div>离线 <span class="numFont mapNum">${params.offlineNums}</span></div>
			</div>
			<div class="mapFlex">
				<div>已注册 <span class="numFont mapNum">${params.bingdingNums}</span></div>
				<div>未注册 <span class="numFont mapNum">${params.unbingdingNums}</span></div>
			</div>
		</div>`
		},
		//根据Hover状态设置相关样式
		toggleHoverFeature(feature, isHover, position) {
			this.tipMarker.setMap(isHover ? this.map : null);

			if (!feature) {
				return;
			}
			let props = feature.properties;
			if (isHover) {
				let key = Object.keys(this.hoverDistrict)[0];
				this.hoverDistrict = {};
				if (this.hoverData[props.adcode]) {
					//保存的上一次hover数据超过10分钟重新请求，减少请求次数
					if (new Date().getTime() - this.hoverData[props.adcode].time > 10 * 60 * 1000) {
						this.getDistrictElvNum(props)
					} else {
						this.tipMarker.setContent(this.markerContent({ name: props.name, ...this.hoverData[props.adcode] }));
						this.tipMarker.setPosition(position || props.center);
						this.hoverDistrict[props.level] = props.name;
					}
				} else if (!(key == props.level && this.hoverDistrict[props.level] == props.name)) {
					//和上一个hover的不相同才获取数据
					this.getDistrictElvNum(props)
				}
			}

			//更新相关多边形的样式
			let polys = this.districtExplorer.findFeaturePolygonsByAdcode(props.adcode);
			for (let i = 0, len = polys.length; i < len; i++) {
				polys[i].setOptions({
					fillOpacity: isHover ? 0.7 : 0.4,
					strokeWeight: isHover ? 2 : 1
				});
			}
		},

		//切换区域
		switch2AreaNode(adcode, callback) {

			if (this.currentAreaNode && ('' + this.currentAreaNode.getAdcode() === '' + adcode)) {
				return;
			}
			let that = this;
			this.loadAreaNode(adcode, function (error, areaNode) {
				if (error) {
					if (callback) {
						callback(error);
					}
					return;
				}
				that.currentAreaNode = areaNode;

				//设置当前使用的定位用节点
				that.districtExplorer.setAreaNodesForLocating([that.currentAreaNode]);

				that.refreshAreaNode(areaNode);

				if (callback) {
					callback(null, areaNode);
				}
			});
		},

		//加载区域
		loadAreaNode(adcode, callback) {
			this.districtExplorer.loadAreaNode(adcode, function (error, areaNode) {
				if (error) {
					if (callback) {
						callback(error);
					}
					return;
				}
				if (callback) {
					callback(null, areaNode);
				}
			});
		},

		//绘制某个区域的边界
		renderAreaPolygons(areaNode) {
			//更新地图视野
			this.map.setBounds(areaNode.getBounds(), null, null, true);

			//清除已有的绘制内容
			this.districtExplorer.clearFeaturePolygons();

			//绘制子区域
			this.districtExplorer.renderSubFeatures(areaNode, {
				cursor: 'default',
				strokeColor: "#00BCFF", //线颜色
				strokeOpacity: 1, //线透明度
				strokeWeight: 1, //线宽
				fillColor: "#2162B3", //填充色
				fillOpacity: 0.4, //填充透明度
			});

			//绘制父区域
			this.districtExplorer.renderParentFeature(areaNode, {
				cursor: 'default',
				strokeColor: '#00BCFF', //线颜色
				strokeOpacity: 0.5, //线透明度
				strokeWeight: 5, //线宽
				fillColor: areaNode.getSubFeatures().length ? null : "#2162B3", //填充色
				fillOpacity: 0.4, //填充透明度
			});
			let bounds = this.map.getBounds();
			this.map.setLimitBounds(bounds);
			this.map.setFitView()
		},

		//切换区域后刷新显示内容
		refreshAreaNode(areaNode) {
			this.districtExplorer.setHoverFeature(null);
			this.renderAreaPolygons(areaNode);

		},
		//处理省市区
		handleDistrict(extraData = {}) {
			//四个直辖市在数据库中存储的是 天津天津市。。。，数据需要改一下
			let specialCity = ["天津", "北京", "重庆", "上海"];
			let filterDistrictObj = {};
			Object.keys(this.districtObj).forEach(key => {
				filterDistrictObj[key] = this.districtObj[key] ? this.districtObj[key].name : null
			})
			let params = { ...filterDistrictObj, ...extraData };
			let index = params.province ? specialCity.findIndex(item => params.province.includes(item)) : -1;
			if (index > -1) {
				params = {
					province: specialCity[index],
					city: params.province,
					area: params.district
				}
			} else {
				params = {
					province: params.province,
					city: params.city,
					area: params.district
				}
			}
			return params
		},
		//地图hover时电梯状态数量
		getDistrictElvNum(props) {
			let params = this.handleDistrict({ [props.level]: props.name });
			this.$api.districtElvNum(params).then(res => {
				if (res.errorCode == 0) {
					//更新提示内容
					this.tipMarker.setContent(this.markerContent({ name: props.name, ...res.data }));
					this.hoverData[props.adcode] = { ...res.data, time: new Date().getTime() };
					this.tipMarker.setPosition(props.center);
					this.hoverDistrict[props.level] = props.name;
				}
			})
		}


	},
	mounted() {
		this.init();
	}
}
</script>



<style scoped>
#mapId {
	width: 100%;
	height: 100%;
	background-color: transparent !important;
}
</style>


<style>
.amap-logo {
	display: none;
	opacity: 0 !important;
}
.amap-copyright {
	opacity: 0;
}
</style>
